module.exports = __webpack_public_path__ + "img/frame (224).edcdc6d4.jpg";